

const ProjetNotifications = () => {
  return (
    <div>ProjetNotifications</div>
  )
}

export default ProjetNotifications